import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_ChanelListComponent from "../components/_FM_chanel/_FM_ChanelListComponent";
import _FM_ChanelFormComponent from "../components/_FM_chanel/_FM_ChanelFormComponent";
import _FM_ChanelShowComponent from "../components/_FM_chanel/_FM_ChanelShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_ChanelPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('reservation_channels') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/channel')
  }, []);

  return (
    <div className="_FM_ChanelPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/channel"}/>
      <Panel>
        <_FM_ChanelListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/channel');
               }}>
        <_FM_ChanelFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/channel');
               }}>
        <_FM_ChanelShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_ChanelPage);
